import {
  CCard,
  CCardHeader,
  CCardBody,
  CButton,
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
  CBadge,
  CRow,
  CCol,
  CAlert,
  CAccordion,
  CAccordionItem,
  CAccordionHeader,
  CAccordionBody,
} from "@coreui/react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import {
  fetchOnboardingList,
  fetchAccountStatus,
} from "../../features/seller/sellerSlice";
import { fetchUserProfile } from "../../features/user/userSlice";
import AppToast from "../../components/seller/AppToast";
import { timeAgo } from "../../utils/timeAgo";
import CIcon from "@coreui/icons-react";
import { cilPlus } from "@coreui/icons";
import { capitalizeFirst } from "../../utils/stringUtils";
import { clearKycWarning } from "../../features/buyer/uiSlice";

const VerificationList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Get the onboarding list and user profile
  const {
    list: onboardingList,
    loading: onboardingLoading,
    error,
  } = useSelector((state) => state.seller.onboarding);
  const { user } = useSelector((state) => state.auth);
  const { loading: statusLoading, data: accountStatus } = useSelector(
    (state) => state.seller.accountStatus,
  );
  const kycWarningMessage = useSelector((state) => state.ui.kycWarningMessage);

  const [toastVisible, setToastVisible] = useState(false);
  const [toastType, setToastType] = useState("info");
  const [toastMessage, setToastMessage] = useState("");
  // console.log("Onboarding List:", onboardingList);

  useEffect(() => {
    dispatch(fetchOnboardingList());
    dispatch(fetchAccountStatus());
    dispatch(fetchUserProfile());

    // Clear the warning after it has been displayed/acknowledged by land on this page
    return () => {
      dispatch(clearKycWarning());
    };
  }, [dispatch]);

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "approved":
        return "success";
      case "pending":
        return "warning";
      case "rejected":
        return "danger";
      default:
        return "secondary";
    }
  };

  if (onboardingLoading || statusLoading)
    return (
      <div className="d-flex justify-content-center p-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );

  // Normalize KYC data to handle both array and single object structures
  const kycList = (() => {
    if (!onboardingList?.kyc) return [];
    // If it's an array, return it (filtering nulls just in case)
    if (Array.isArray(onboardingList.kyc))
      return onboardingList.kyc.filter(Boolean);
    // If it's a single object, wrap it in an array to match the map expectation
    return [onboardingList.kyc];
  })();

  const getDocumentsFromItem = (item) => {
    const docs = [];
    // The API uses document_type1, document_type2, etc. (up to 4 observed)
    for (let i = 1; i <= 4; i++) {
      const type = item[`document_type${i}`];
      const url = item[`document_url${i}`] || item[`document_path${i}`];
      if (type || url) {
        docs.push({ type, url });
      }
    }
    // Fallback for objects that might use non-numbered keys
    if (docs.length === 0 && item.document_type) {
      docs.push({
        type: item.document_type,
        url: item.document_url || item.document_path,
      });
    }
    return docs;
  };

  const getPayoutVerificationStatus = (
    payout,
    stripeConnected,
    bankVerificationStatus,
  ) => {
    const method =
      payout == null
        ? null
        : typeof payout === "string"
          ? payout
          : payout?.method;

    if (!method) return "Not Submitted";

    if (method === "stripe") {
      return stripeConnected === 1 ? "Approved" : "Not Set";
    }

    if (method === "bank") {
      if (bankVerificationStatus === "approved") return "Approved";
      if (bankVerificationStatus === "rejected") return "Rejected";
      if (
        bankVerificationStatus === undefined ||
        bankVerificationStatus === null ||
        bankVerificationStatus === ""
      )
        return "Not Set";
      return "Pending";
    }

    return "Not Set";
  };

  const handleAddDocumentClick = () => {
    // Always allow navigation to KYC form
    navigate("/seller/verification-form?section=kyc");
  };

  const getAlertConfig = () => {
    const isKycApproved = onboardingList?.kyc?.status === "approved";
    const payoutStatus = getPayoutVerificationStatus(
      onboardingList?.payout,
      onboardingList?.stripe_connected,
      onboardingList?.bank?.verification_status,
    );
    const isPayoutApproved = payoutStatus === "Approved";

    if (isKycApproved && isPayoutApproved) return null;

    let message = kycWarningMessage || "You are now basic seller, please complete your profile verification to unlock all features like seamless payout.";
    let details = [];
    console.log('Message:',message)


    if (!isKycApproved) {
      const kycStatus = onboardingList?.kyc?.status || "not submitted";
      details.push(`Identity Verification: ${capitalizeFirst(kycStatus)}`);
    }

    if (!isPayoutApproved) {
      details.push(`Payout Verification: ${payoutStatus}`);
    }
    
    return {
      color: "warning",
      message,
      details,
    };
  };

  const alertConfig = getAlertConfig();

  // return (
  //   <div className="verification-list-container">
  //     <AppToast
  //       visible={toastVisible}
  //       setVisible={setToastVisible}
  //       type={toastType}
  //       message={toastMessage}
  //     />

  //     {alertConfig && (
  //       <CAlert
  //         color={alertConfig.color}
  //         className="mb-4 shadow-sm border-0 d-flex align-items-center"
  //       >
  //         <CIcon
  //           icon={cilPlus}
  //           className="me-3 fs-4 rotate-45"
  //           style={{ transform: "rotate(45deg)" }}
  //         />
  //         <div>
  //           <div className="fw-bold">{alertConfig.message}</div>
  //           <div className="small opacity-75">
  //             {alertConfig.details.join(" | ")}
  //           </div>
  //         </div>
  //       </CAlert>
  //     )}

  //     <div className="d-flex justify-content-between align-items-center mb-4">
  //       <h4 className="mb-0 fw-bold">Verification Status</h4>
  //       <CButton color="primary" onClick={handleAddDocumentClick}>
  //         <CIcon icon={cilPlus} className="me-2" />
  //         Add Document
  //       </CButton>
  //     </div>

  //     <CCard className="shadow-sm border-0">
  //       <CCardHeader className="bg-white py-3">
  //         <h5 className="mb-0 fw-bold">KYC Submission History</h5>
  //       </CCardHeader>

  //       <CCardBody>
  //         <CTable hover responsive align="middle" className="mb-0">
  //           <CTableHead color="light">
  //             <CTableRow>
  //               <CTableHeaderCell>#</CTableHeaderCell>
  //               <CTableHeaderCell>KYC Type</CTableHeaderCell>
  //               <CTableHeaderCell>Document Type</CTableHeaderCell>
  //               <CTableHeaderCell>Uploaded File</CTableHeaderCell>
  //               <CTableHeaderCell>Consent</CTableHeaderCell>
  //               <CTableHeaderCell>Payment Method</CTableHeaderCell>
  //               <CTableHeaderCell>Verification Status</CTableHeaderCell>
  //               <CTableHeaderCell>Payout Verification Status</CTableHeaderCell>
  //               <CTableHeaderCell>Verification Reject Reason</CTableHeaderCell>
  //               <CTableHeaderCell>Payout Reject Reason</CTableHeaderCell>
  //               <CTableHeaderCell>Uploaded Date</CTableHeaderCell>
  //             </CTableRow>
  //           </CTableHead>

  //           <CTableBody>
  //             {kycList.length > 0 ? (
  //               kycList.map((item, index) => {
  //                 const docs = getDocumentsFromItem(item);
  //                 const payoutStatus = getPayoutVerificationStatus(
  //                   onboardingList?.payout,
  //                   onboardingList?.stripe_connected,
  //                   onboardingList?.bank?.verification_status,
  //                 );

  //                 console.log(
  //                   "Payout:",
  //                   onboardingList.payout,
  //                   onboardingList.stripe_connected,
  //                   onboardingList.bank?.verification_status,
  //                   payoutStatus,
  //                 );

  //                 return (
  //                   <CTableRow key={item.id}>
  //                     <CTableDataCell className="text-center">
  //                       {index + 1}
  //                     </CTableDataCell>
  //                     <CTableDataCell className="text-capitalize">
  //                       {item.kyc_type}
  //                     </CTableDataCell>
  //                     <CTableDataCell>
  //                       {docs.map((d, idx) => (
  //                         <div
  //                           key={idx}
  //                           className={`${idx > 0 ? "mt-2 pt-2 border-top" : ""} fw-semibold`}
  //                         >
  //                           {d.type || "N/A"}
  //                         </div>
  //                       ))}
  //                     </CTableDataCell>
  //                     <CTableDataCell>
  //                       {docs.map((d, idx) => (
  //                         <div
  //                           key={idx}
  //                           className={idx > 0 ? "mt-2 pt-2 border-top" : ""}
  //                         >
  //                           {d.url ? (
  //                             <CButton
  //                               size="sm"
  //                               color="primary"
  //                               onClick={() => window.open(d.url, "_blank")}
  //                               className="fw-semibold"
  //                             >
  //                               View
  //                             </CButton>
  //                           ) : (
  //                             "-"
  //                           )}
  //                         </div>
  //                       ))}
  //                     </CTableDataCell>
  //                     <CTableDataCell>
  //                       {item.is_consent ? (
  //                         <CBadge color="success" shape="rounded-pill">
  //                           Given
  //                         </CBadge>
  //                       ) : (
  //                         <CBadge color="secondary" shape="rounded-pill">
  //                           None
  //                         </CBadge>
  //                       )}
  //                     </CTableDataCell>
  //                     <CTableDataCell className="text-capitalize blockquote">
  //                       {onboardingList?.payout?.method || "N/A"}
  //                     </CTableDataCell>
  //                     <CTableDataCell>
  //                       <CBadge color={getStatusColor(item.status)}>
  //                         {item.status === "pending"
  //                           ? "Pending"
  //                           : capitalizeFirst(item.status)}
  //                       </CBadge>
  //                     </CTableDataCell>
  //                     <CTableDataCell>
  //                       {/* Payout Verification Status */}
  //                       <CBadge color={getStatusColor(payoutStatus)}>
  //                         {payoutStatus}
  //                       </CBadge>
  //                     </CTableDataCell>
  //                     <CTableDataCell className="text-danger small">
  //                       {item.status === "rejected"
  //                         ? item.reason || "N/A"
  //                         : "-"}
  //                     </CTableDataCell>
  //                     <CTableDataCell className="text-danger small">
  //                       {/* FIXED: Show payout reject reason from bank.verification_comment */}
  //                       {payoutStatus === "Rejected" &&
  //                       onboardingList?.bank?.verification_comment
  //                         ? onboardingList.bank.verification_comment
  //                         : "-"}
  //                     </CTableDataCell>
  //                     <CTableDataCell className="small text-muted">
  //                       {item.created_at ? timeAgo(item.created_at) : "N/A"}
  //                     </CTableDataCell>
  //                   </CTableRow>
  //                 );
  //               })
  //             ) : (
  //               <CTableRow>
  //                 <CTableDataCell
  //                   colSpan={11}
  //                   className="text-center py-4 text-muted"
  //                 >
  //                   No KYC documents found. Click "Add Document" to begin.
  //                 </CTableDataCell>
  //               </CTableRow>
  //             )}
  //           </CTableBody>
  //         </CTable>
  //       </CCardBody>
  //     </CCard>
  //   </div>
  // );
  return (
    <div className="verification-list-container">
      <AppToast
        visible={toastVisible}
        setVisible={setToastVisible}
        type={toastType}
        message={toastMessage}
      />

      {alertConfig && (
        <CAlert
          color={alertConfig.color}
          className="mb-4 shadow-sm border-0 d-flex align-items-center"
        >
          <CIcon
            icon={cilPlus}
            className="me-3 fs-4"
            style={{ transform: "rotate(45deg)" }}
          />
          <div>
            <div className="fw-bold">{alertConfig.message}</div>
            <div className="small opacity-75">
              {alertConfig.details.join(" | ")}
            </div>
          </div>
        </CAlert>
      )}

      <div className="mb-4">
        <h4 className="fw-bold mb-1">Account Verification</h4>
        <div className="text-muted small">
          Manage your identity verification, payout setup and address details.
        </div>
      </div>

      <div className="d-flex flex-wrap justify-content-end gap-2 mb-4">
        {/* Identity */}
        <CButton color="primary" onClick={handleAddDocumentClick}>
          Add Document
        </CButton>

        {/* Payment */}
        <CButton
          color="primary"
          variant="outline"
          onClick={() => navigate("/seller/verification-form?section=payout")}
        >
          {onboardingList?.payout?.method ? "Update Payment" : "Setup Payment"}
        </CButton>

        {/* Address */}
        <CButton
          color="primary"
          variant="outline"
          onClick={() => navigate("/seller/verification-form?section=address")}
        >
          {onboardingList?.address ? "Edit Address" : "Add Address"}
        </CButton>
      </div>

      {/* Status Summary */}
      <CCard className="border-0 shadow-sm mb-4">
        <CCardBody className="py-4">
          {/* Section Title */}
          <div className="mb-4">
            <h5 className="fw-bold mb-1">Verification Overview</h5>
            <div className="text-muted small">
              Track the completion status of your account setup.
            </div>
          </div>

          <CRow>
            {/* Identity */}
            <CCol md={4} className="mb-3 mb-md-0">
              <div className="p-3 rounded border h-100 text-center bg-light bg-opacity-50">
                <div className="fw-semibold mb-2">Identity Verification</div>

                <CBadge
                  color={getStatusColor(onboardingList?.kyc?.status)}
                  shape="rounded-pill"
                  className="px-4 py-2"
                >
                  {onboardingList?.kyc?.status
                    ? capitalizeFirst(onboardingList.kyc.status)
                    : "Not Submitted"}
                </CBadge>
              </div>
            </CCol>

            {/* Payout */}
            <CCol md={4} className="mb-3 mb-md-0">
              <div className="p-3 rounded border h-100 text-center bg-light bg-opacity-50">
                <div className="fw-semibold mb-2">Payout Setup</div>

                {(() => {
                  const payoutStatus = getPayoutVerificationStatus(
                    onboardingList?.payout,
                    onboardingList?.stripe_connected,
                    onboardingList?.bank?.verification_status,
                  );

                  return (
                    <CBadge
                      color={getStatusColor(payoutStatus)}
                      shape="rounded-pill"
                      className="px-4 py-2"
                    >
                      {payoutStatus}
                    </CBadge>
                  );
                })()}
              </div>
            </CCol>

            {/* Address */}
            <CCol md={4}>
              <div className="p-3 rounded border h-100 text-center bg-light bg-opacity-50">
                <div className="fw-semibold mb-2">Address</div>

                <CBadge
                  color={onboardingList?.address ? "success" : "secondary"}
                  shape="rounded-pill"
                  className="px-4 py-2"
                >
                  {onboardingList?.address ? "Added" : "Not Added"}
                </CBadge>
              </div>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>

      <CAccordion alwaysOpen activeItemKey={1}>
        <CAccordionItem itemKey={1}>
          <CAccordionHeader>Identity Verification</CAccordionHeader>
          <CAccordionBody>
            <VerificationSection
              kycList={kycList}
              onboardingList={onboardingList}
              getStatusColor={getStatusColor}
              getDocumentsFromItem={getDocumentsFromItem}
              getPayoutVerificationStatus={getPayoutVerificationStatus}
              handleAddDocumentClick={handleAddDocumentClick}
            />
          </CAccordionBody>
        </CAccordionItem>

        <CAccordionItem itemKey={2}>
          <CAccordionHeader>Payment Details</CAccordionHeader>
          <CAccordionBody>
            <PaymentSection
              onboardingList={onboardingList}
              getStatusColor={getStatusColor}
              getPayoutVerificationStatus={getPayoutVerificationStatus}
            />
          </CAccordionBody>
        </CAccordionItem>

        <CAccordionItem itemKey={3}>
          <CAccordionHeader>Address Information</CAccordionHeader>
          <CAccordionBody>
            <AddressSection onboardingList={onboardingList} />
          </CAccordionBody>
        </CAccordionItem>
      </CAccordion>
    </div>
  );
};

export default VerificationList;

const VerificationSection = ({
  kycList,
  getStatusColor,
  getDocumentsFromItem,
  handleAddDocumentClick,
}) => {
  return (
    <CCard className="border-0 shadow-sm">
      <CCardBody>
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h6 className="fw-bold mb-1">Submitted Documents</h6>
            <div className="small text-muted">
              Manage your identity verification documents.
            </div>
          </div>

          {/* <CButton color="primary" onClick={handleAddDocumentClick}>
            <CIcon icon={cilPlus} className="me-2" />
            Add Document
          </CButton> */}
        </div>

        {/* Table */}
        <CTable
          hover
          responsive
          align="middle"
          className="border rounded overflow-hidden"
        >
          <CTableHead className="bg-light">
            <CTableRow>
              <CTableHeaderCell className="small text-muted">
                #
              </CTableHeaderCell>
              <CTableHeaderCell className="small text-muted">
                Verification Type
              </CTableHeaderCell>
              <CTableHeaderCell className="small text-muted">
                Documents
              </CTableHeaderCell>
              <CTableHeaderCell className="small text-muted">
                Consent
              </CTableHeaderCell>
              <CTableHeaderCell className="small text-muted">
                Status
              </CTableHeaderCell>
              <CTableHeaderCell className="small text-muted">
                Reject Reason
              </CTableHeaderCell>
              <CTableHeaderCell className="small text-muted">
                Uploaded
              </CTableHeaderCell>
            </CTableRow>
          </CTableHead>

          <CTableBody>
            {kycList.length > 0 ? (
              kycList.map((item, index) => {
                const docs = getDocumentsFromItem(item);

                return (
                  <CTableRow key={item.id}>
                    <CTableDataCell className="fw-semibold">
                      {index + 1}
                    </CTableDataCell>

                    <CTableDataCell className="text-capitalize fw-semibold">
                      {item.kyc_type}
                    </CTableDataCell>

                    {/* Documents */}
                    <CTableDataCell>
                      {docs.length > 0 ? (
                        docs.map((d, idx) => (
                          <div
                            key={idx}
                            className={`d-flex align-items-center justify-content-between ${idx > 0 ? "mt-2 pt-2 border-top" : ""
                              }`}
                          >
                            <span className="small fw-semibold">
                              {d.type || "Document"}
                            </span>

                            {d.url && (
                              <CButton
                                size="sm"
                                color="light"
                                className="ms-3"
                                onClick={() => window.open(d.url, "_blank")}
                              >
                                View
                              </CButton>
                            )}
                          </div>
                        ))
                      ) : (
                        <span className="text-muted small">No documents</span>
                      )}
                    </CTableDataCell>

                    {/* Consent */}
                    <CTableDataCell>
                      {item.is_consent ? (
                        <CBadge color="success" shape="rounded-pill">
                          Given
                        </CBadge>
                      ) : (
                        <CBadge color="secondary" shape="rounded-pill">
                          None
                        </CBadge>
                      )}
                    </CTableDataCell>

                    {/* Status */}
                    <CTableDataCell>
                      <CBadge
                        color={getStatusColor(item.status)}
                        shape="rounded-pill"
                        className="px-3 py-2"
                      >
                        {capitalizeFirst(item.status)}
                      </CBadge>
                    </CTableDataCell>

                    {/* Reject Reason */}
                    <CTableDataCell>
                      {item.status === "rejected" ? (
                        <div className="text-danger small fw-semibold">
                          {item.reason || "No reason provided"}
                        </div>
                      ) : (
                        <span className="text-muted small">—</span>
                      )}
                    </CTableDataCell>

                    {/* Uploaded */}
                    <CTableDataCell className="small text-muted">
                      {item.created_at ? timeAgo(item.created_at) : "N/A"}
                    </CTableDataCell>
                  </CTableRow>
                );
              })
            ) : (
              <CTableRow>
                <CTableDataCell colSpan={12} className="text-center py-5">
                  <div className="mb-2 fw-semibold">
                    No verification documents yet
                  </div>
                  <div className="small text-muted mb-3">
                    Start by uploading your identity documents.
                  </div>
                </CTableDataCell>
              </CTableRow>
            )}
          </CTableBody>
        </CTable>
      </CCardBody>
    </CCard>
  );
};

const PaymentSection = ({
  onboardingList,
  getStatusColor,
  getPayoutVerificationStatus,
}) => {
  const bank = onboardingList?.bank;
  const payoutMethod = onboardingList?.payout?.method;

  const payoutStatus = getPayoutVerificationStatus(
    onboardingList?.payout,
    onboardingList?.stripe_connected,
    bank?.verification_status,
  );

  return (
    <CCard className="border-0 shadow-sm">
      <CCardBody>
        <CRow className="mb-3">
          <CCol md={4} className="fw-semibold text-muted">
            Payout Method
          </CCol>
          <CCol md={8} className="text-capitalize">
            {payoutMethod || "Not Set"}
          </CCol>
        </CRow>

        {payoutMethod === "bank" && bank && (
          <>
            <CRow className="mb-3">
              <CCol md={4} className="fw-semibold text-muted">
                Bank Name
              </CCol>
              <CCol md={8}>{bank.bank_name}</CCol>
            </CRow>

            <CRow className="mb-3">
              <CCol md={4} className="fw-semibold text-muted">
                Account Holder
              </CCol>
              <CCol md={8}>{bank.account_holder_name}</CCol>
            </CRow>

            <CRow className="mb-3">
              <CCol md={4} className="fw-semibold text-muted">
                Account Type
              </CCol>
              <CCol md={8} className="text-capitalize">
                {bank.account_type}
              </CCol>
            </CRow>

            <CRow className="mb-3">
              <CCol md={4} className="fw-semibold text-muted">
                BSB
              </CCol>
              <CCol md={8}>{bank.bsb}</CCol>
            </CRow>

            <CRow className="mb-3">
              <CCol md={4} className="fw-semibold text-muted">
                Verification Status
              </CCol>
              <CCol md={8}>
                <CBadge color={getStatusColor(bank.verification_status)}>
                  {capitalizeFirst(bank.verification_status)}
                </CBadge>
              </CCol>
            </CRow>

            {bank.verification_status === "rejected" &&
              bank.verification_comment && (
                <CRow>
                  <CCol md={4} className="fw-semibold text-muted">
                    Reject Reason
                  </CCol>
                  <CCol md={8} className="text-danger small">
                    {bank.verification_comment}
                  </CCol>
                </CRow>
              )}
          </>
        )}

        {payoutMethod === "stripe" && (
          <CRow>
            <CCol md={4} className="fw-semibold text-muted">
              Stripe Status
            </CCol>
            <CCol md={8}>
              <CBadge
                color={
                  onboardingList?.stripe_connected === 1 ? "success" : "warning"
                }
              >
                {onboardingList?.stripe_connected === 1
                  ? "Connected"
                  : "Not Connected"}
              </CBadge>
            </CCol>
          </CRow>
        )}
      </CCardBody>
    </CCard>
  );
};

const AddressSection = ({ onboardingList }) => {
  const address = onboardingList?.address;

  return (
    <CCard className="border-0 shadow-sm">
      <CCardBody>
        {address ? (
          <>
            <div className="fw-semibold text-capitalize mb-2">
              {address.address_type} Address
              {address.isDefault === 1 && (
                <CBadge color="success" className="ms-2">
                  Default
                </CBadge>
              )}
            </div>

            <div>{address.addressLine1}</div>

            {address.addressLine2 && <div>{address.addressLine2}</div>}

            <div>
              {address.city}, {address.state}
            </div>

            <div>
              {address.postal_code} - {address.region}
            </div>

            <div className="small text-muted mt-3">
              Last updated: {timeAgo(address.updated_at)}
            </div>
          </>
        ) : (
          <div className="text-muted">No address information available.</div>
        )}
      </CCardBody>
    </CCard>
  );
};
